import React from 'react';
import { observer } from 'mobx-react';
import { Typography } from '@mui/material';
const LinearPileupDisplayBlurb = observer(function ({ model, }) {
    var _a;
    const { sortedBy } = model;
    return sortedBy ? (React.createElement("div", { "data-testid": `blurb-${sortedBy}` },
        React.createElement(Typography, { color: "secondary", variant: "caption" }, sortedBy
            ? `Sorted by ${(_a = sortedBy.tag) !== null && _a !== void 0 ? _a : sortedBy.type} at ${sortedBy.refName}:${sortedBy.pos}`
            : null))) : null;
});
export default LinearPileupDisplayBlurb;
